import React, { useState, useContext, useEffect } from "react";

import lbl from "../../../data/Labels.json";

import { HalfYearContext } from "../../../contexts/halfYearContext";

import db from "../../../services/query";

import MainButton from "../../common/MainButton";
import MainTitle from "../../common/MainTitle";
import MainBodyTabs from "../../common/MainBodyTabs";

import Routes from "./Routes";
import MainPrintLink from "../../common/MainPrint";

const Dashboard = (props) => {
  const tabs = [
    {
      name: "گزارش عمومی",
      path: "general",
    },
    {
      name: "گزارش روزانه",
      path: "daily",
    },
    {
      name: "گزارش حسابات",
      path: "accountReports",
    },
  ];

  const { halfYear } = useContext(HalfYearContext);
  const [generalData, setGeneralData] = useState([]);

  const chartCacheKey = (id) => `chartData:${id || "none"}`;

  const requestGeneralReportData = async (p = new Object()) => {
    const { halfYear } = p;
    if (!halfYear) return;

    let query = `dashboard/finance?halfYearId=${halfYear}`;

    await db.getAll(query).then(({ data }) => {
      setGeneralData(data?.data[0]);

      sessionStorage.setItem(
        chartCacheKey(halfYear),
        JSON.stringify({ ...data?.data[0] })
      );
    });
  };

  useEffect(() => {
    const ac = new AbortController();
    if (!halfYear) return () => ac.abort();

    const chartData = sessionStorage.getItem(chartCacheKey(halfYear));
    if (chartData) {
      try {
        setGeneralData(JSON.parse(chartData));
      } catch (_e) {
        requestGeneralReportData({ halfYear });
      }
    } else {
      requestGeneralReportData({ halfYear });
    }

    return () => ac.abort();
  }, [halfYear]);

  const renderRefreshButton = () => {
    return (
      props.match.params.path === "general" && (
        <MainButton
          title={lbl.RefreshData}
          type={"refresh"}
          handleClick={() => requestGeneralReportData({ halfYear })}
        />
      )
    );
  };

  const renderAccountReportPrint = () => {
    return (
      props.match.params.path === "accountReports" && (
        <MainPrintLink path={`finance/dashboard/accountReports`} />
      )
    );
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainTitle title={lbl.Report} />
        </div>
        <div className="left-content">
          {renderRefreshButton()}
          {renderAccountReportPrint()}
        </div>
      </div>
      <div className="main-content-body fixed-height-square ">
        <MainBodyTabs tabs={tabs} {...props} />
        <Routes {...props} generalData={generalData} />
      </div>
    </div>
  );
};

export default Dashboard;
